import moment from 'moment';

export function validarCpf(cpf) {
    if (!cpf || cpf === '') {
        return true;
    }

    cpf = cpf.replace(/[^\d]+/g, '');
    if (cpf === '') {
        return false;
    }

    const listaCpfsInvalidos = ["00000000000", "11111111111", "22222222222", "33333333333", "44444444444",
        "55555555555", "66666666666", "77777777777", "88888888888", "99999999999"];

    if (cpf.length !== 11 || listaCpfsInvalidos.includes(cpf)) {
        return false;
    }

    let soma = 0;
    for (let i = 0; i < 9; i++) {
        soma += parseInt(cpf.charAt(i)) * (10 - i);
    }
    let rev = 11 - (soma % 11);
    if (rev === 10 || rev === 11) {
        rev = 0;
    }
    if (rev !== parseInt(cpf.charAt(9))) {
        return false;
    }
    soma = 0;
    for (let i = 0; i < 10; i++) {
        soma += parseInt(cpf.charAt(i)) * (11 - i);
    }
    rev = 11 - (soma % 11);
    if (rev === 10 || rev === 11) {
        rev = 0;
    }
    if (rev !== parseInt(cpf.charAt(10)))
        return false;

    return true;
}

export function tempoValida(hora, diaReferencia) {
  const dia = moment(diaReferencia).isSame(moment(), 'day');
  if (!dia && moment(hora).isValid()) return true;
  else
    return hora instanceof Date && !isNaN(hora) && moment(hora).isSameOrBefore(moment().add(1, 'hour'), 'minute');
}
